import { useCallback, useRef } from 'react'
import type { NativeScrollEvent, NativeSyntheticEvent } from 'react-native'
import { productTelemetryService } from '../services/product-telemetry.service'

type ScrollHandler = (event: NativeSyntheticEvent<NativeScrollEvent>) => void

const DEPTH_THRESHOLDS = [25, 50, 75, 100] as const

export function useProductTelemetryScroll(
  elementId: string,
  downstreamHandler?: ScrollHandler,
): ScrollHandler {
  const reachedRef = useRef<Set<number>>(new Set())

  return useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      downstreamHandler?.(event)

      const { contentOffset, contentSize, layoutMeasurement } = event.nativeEvent
      const contentHeight = contentSize.height
      const viewportHeight = layoutMeasurement.height
      if (!contentHeight || contentHeight <= viewportHeight) return

      const visibleBottom = Math.max(0, contentOffset.y) + viewportHeight
      const depth = Math.min(100, Math.round((visibleBottom / contentHeight) * 100))
      for (const threshold of DEPTH_THRESHOLDS) {
        if (depth >= threshold && !reachedRef.current.has(threshold)) {
          reachedRef.current.add(threshold)
          productTelemetryService.recordScrollDepth({ depthPct: threshold, elementId })
        }
      }
    },
    [downstreamHandler, elementId],
  )
}
